import {useSocketNotifications} from "./WebSocketProvider";
import {useEffect, useState} from "react";
import {styled} from "@mui/material";
import {grey, yellow} from "@mui/material/colors";
import {Cached} from "@mui/icons-material";
import {css} from "@emotion/css";

export function BackgroundTasks() {
    const [list, setList] = useState<{
        key: string,
        label: string,
        added: Date;
        removed: boolean;
    }[]>([]);

    useSocketNotifications("product_search_view_refreshed", (input: {status: "start" | "done"}) => {
        const key = "product_search_view_refreshed";

        if(input.status === "start") {
            setList(prev => [...prev.filter(v => v.key !== key), {
                key: key,
                label: "Refreshing product search view",
                added: new Date(),
                removed: false,
            }])
        } else {
            setList(prev => prev.map(p => {
                if(p.key === key) {
                    return {
                        ...p,
                        removed: true,
                    }
                }

                return p;
            }))
        }
    }, []);

    const hasPendingRemoval = list.some(v => v.removed);

    useEffect(() => {
        if(!hasPendingRemoval) return;

        const interval = setInterval(() => {
            setList(prev => prev.filter(v => {
                if(v.removed) {
                    const diff = new Date().getTime() - v.added.getTime();
                    if(diff > 2000) {
                        return false
                    }
                }

                return true
            }));
        }, 500);
        return () => clearInterval(interval);
    }, [hasPendingRemoval]);

    if(list.length === 0) return null;

    return (
        <Outer style={{
            display: "flex",
            flexDirection: "column",
        }}>
            {list.map((x, i) => (
                <Element key={i}>
                    <span style={{
                        fontSize: "1.2rem",
                        height: "1.2em",
                    }}>
                        <Cached fontSize="inherit" className={rotateCss} />
                    </span>
                    {x.label}
                </Element>
            ))}
        </Outer>
    )
}

const rotateCss = css({
    padding: 0,
    margin: 0,

    animation: "rotate 5s linear infinite",
    "@keyframes rotate": {
        from: {
            transform: "rotate(360deg)",
        },
        to: {
            transform: "rotate(0deg)",
        },
    },
})


export const Outer = styled("div")(() => ({
    border: "1px solid hsla(0, 100%, 100%, 0.6)",
    borderRadius: 4,
    backgroundColor: "hsla(0, 100%, 100%, 0.4)",
    color: "white",
    display: "flex",
    position: "relative",
}))

export const Element = styled("div")<{
    selected?: boolean
    locked?: boolean
}>(props => ({
    paddingLeft: 8,
    paddingRight: 15,
    display: "flex",
    alignItems: "center",
    paddingTop: 5,
    gap: 4,

    fontSize: "0.7rem",
    textTransform: "uppercase",
    fontWeight: 500,

    color: grey["900"],
    marginBottom: -1,
    cursor: "pointer",

    "&:hover": {
        color: yellow["700"],
    },

    "&:first-of-type": {
        // paddingLeft: 20,
    },
    "&:last-of-type": {
        paddingRight: 20,
    }
}))